<template>
	<div class="pt-5">
		<div class="w-mobile mx-auto px-3">
			<div class="text-center w-100 mb-3">
				<img src="/images/stan-logo-text.svg" class="mr-2" width="107px" height="37px" alt="logo" />
				<p class=" text-large mt-2">{{ $t('Get your bag 💰💸😤') }}</p>
			</div>
			<div>
				<MFAValidation
					:configName="mfaConfigName"
					:nextRoute="mfaLoginEndpoint"
					:token="mfaToken"
					@close="() => (submittingForm = false)"
				></MFAValidation>
			</div>

			<div class="d-flex justify-content-center mt-5 pt-3 mb-5">
				<form class="validate-form w-100" id="login" @submit.prevent="loginUser" @keydown="form.onKeydown($event)">
					<AppInput
						v-model="form.email_or_username"
						class="form-group"
						:error="ajax_error.errors && ajax_error.errors.email_or_username ? ajax_error.errors.email_or_username : []"
						:icon="emailOrUsernameImage"
						type="text"
						placeholder="Email or Username"
						data-test-id="login-input"
					/>
					<AppInput
						v-model="form.password"
						class="form-group"
						:error="ajax_error.errors.password"
						icon="/images/icons/ic-lock.svg"
						:placeholder="$t('Password')"
						type="password"
						data-test-id="password-input"
					/>
					<div class="form-group mb-0">
						<AppButton
							name="login-submit-button"
							fullwidth
							size="large"
							class="w-100"
							:disabled="submittingForm"
							:loading="submittingForm"
							data-test-id="submit-button"
							>{{ $t('Sign In') }}</AppButton
						>
						<span
							v-if="ajax_error && ajax_error.message && ajax_error.errors.length === 0"
							class="error-message stan-text-danger f-14 pt-2"
						>
							{{ ajax_error.message }}
						</span>
						<RouterLink :to="{ name: 'forgot_password' }" class="d-block w-100 text-center mt-2">{{ $t('Forgot password?') }}</RouterLink>
					</div>
				</form>
			</div>
			<p class="text-center">
				{{ $t("Don't have an account?") }}
				<RouterLink
					:to="{
						name: 'register',
					}"
					class="underline-text text-bold"
					data-test-id="register-link"
					>{{ $t('Register') }}
				</RouterLink>
			</p>
			<template v-if="hasExistingAccount">
				<hr />
				<p class="text-center ">
					<a class="text-bold underline-text" @click.prevent="backToLoggedInAccount">Go back to dashboard</a>
				</p>
			</template>
		</div>
	</div>
</template>
<script id="ads"></script>
<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex'
	import Form from 'vform'
	import Cookies from 'js-cookie'
	import helper from '~/global_helper/helpers'
	import authMixin from './authMixin.js'
	import MFAValidation from './MFAValidationModal'

	export default {
		middleware: 'guest',
		mixins: [authMixin],
		data: () => ({
			form: new Form({}),
			remember: false,
			spanLogin: 'flex',
			spanSpinner: 'none',
			status: '',
			message: '',
			submittingForm: false,
			mfaLoginEndpoint: '',
			mfaToken: '',
			mfaConfigName: '',
		}),
		components: {
			MFAValidation,
		},
		created() {
			Cookies.remove('stan_reg_process')
			localStorage.removeItem('section_array')
			let uri = window.location.search.substring(1)
			let params = new URLSearchParams(uri)
			var url_token = params.get('token')
			var redirectTo = params.get('redirectTo')
			if (redirectTo) {
				sessionStorage.setItem('redirectTo', redirectTo)
			}
			if (this.loginMethod === 'username') {
				sessionStorage.setItem('redirectTo', '/account_settings')
			}
			if (url_token != '' && url_token != null) {
				// Check if any existing accounts are admin and flag this method of account login
				localStorage.clear()
				this.$store.dispatch('Auth/saveToken', { token: url_token, tmpLoginAsAdmin: true })
				this.loadRedirectUser()
			}
			this.resetState()
			setInterval(
				function() {
					$('.alertDiv').hide()
				}.bind(this),
				20000
			)
		},
		computed: {
			...mapGetters('Auth', ['ajax_error', 'addAccountFlag', 'accounts', 'last_account_key']),
			hasExistingAccount() {
				if (this.last_account_key && this.accounts[this.last_account_key]) {
					return true
				}
				return false
			},
			loginMethod() {
				if (this.$route.query.method === 'username') {
					return 'username'
				}
				return 'email'
			},
			emailOrUsernameImage() {
				if (this.$commonHelper.validateEmail(this.form.email_or_username)) return '/images/icons/ic-mail.svg'
				else return '/images/icons/ic-person.svg'
			},
		},
		methods: {
			...mapMutations('Auth', ['switchAccount', 'prepareToAddAccount']),
			...mapActions('Auth', ['login', 'saveToken', 'fetchUser', 'resetState']),
			async backToLoggedInAccount() {
				this.submittingForm = true
				if (this.hasExistingAccount) {
					this.switchAccount(this.last_account_key)
				}
				await this.$store.dispatch('Auth/fetchUser')
				this.$router.push({ name: 'dashboard' })
				this.submittingForm = false
			},
			validateForm() {
				let formStatus = true
				let errorObject = {
					status: 'error',
					message: this.$t('The given data was invalid.'),
					errors: {},
				}

				if (this.showJustEmailOrUsername) {
					if (helper.stringLength(this.form.email_or_username) == 0) {
						Object.assign(errorObject.errors, {
							email_or_username: [this.$t(`Please enter ${this.loginMethod}.`)],
						})
						formStatus = false
					}
					if (this.loginMethod === 'email')
						if (helper.stringLength(this.form.email_or_username) != 0 && !helper.validateEmail(this.form.email_or_username)) {
							Object.assign(errorObject.errors, {
								email_or_username: [this.$t('Email is not valid.')],
							})
							formStatus = false
						}
				} else {
					if (helper.stringLength(this.form.email_or_username) == 0) {
						Object.assign(errorObject.errors, {
							email_or_username: [this.$t('Please enter email address or username.')],
						})
						formStatus = false
					}
				}

				if (helper.stringLength(this.form.password) == 0) {
					Object.assign(errorObject.errors, {
						password: [this.$t('Please enter Password.')],
					})
					formStatus = false
				}

				this.$store.dispatch('Auth/raiseAjaxError', errorObject)
				return formStatus
			},

			loginUser() {
				let status = this.validateForm()
				if (status) {
					this.submittingForm = true
					this.login(this.form)
						.then(response => {
							if (response.data?.mfa_token) {
								this.mfaLoginEndpoint = helper.removePrefix(response.data?.route, '/api/')
								this.mfaToken = response.data?.mfa_token
								this.mfaConfigName = response.data?.config_name
							}

							this.loadRedirectUser()
						})
						.catch(error => {
							this.$logError(error)
							this.submittingForm = false
						})
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
	.f-14 {
		font-size: 14px !important;
	}
	#login::v-deep {
		.left-icon {
			svg {
				path {
					fill: var(--stan-text-light-color);
				}
			}
		}
	}
</style>
